export enum UserActionsOptionsEnum {
  RESEND_CONFIRMATION_EMAIL = 'resendConfirmationEmail',
  DELETE = 'delete',
  EDIT = 'edit',
}
